import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChangeMgmtComponent} from './change-mgmt.component';
import {ChangeMgmtRoutingModule} from 'src/app/main/change-mgmt/change-mgmt-routing.module';
import {BreadcrumbModule} from '../../components/breadcrumb/breadcrumb.module';
import {SharedModule} from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    ChangeMgmtComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    ChangeMgmtRoutingModule
  ]
})
export class ChangeMgmtModule {
}
